import styled from "styled-components";
import { Avatar as AvatarBUI } from "discover.medical.react-component-library";

export const Avatar = styled(AvatarBUI)`
  margin-right: ${({ theme }) => theme.space.md};
  display: flex;

  @media (min-width: 640px) and (max-width: 767px) {
    margin-right: 0;
    display: none;
  }
`;
